<template>
	<component v-bind:is="iframeModal ? 'layout-blank' : 'layout-splash'">
		<form
			class="h-full flex flex-col"
			@submit.prevent="tryGotoStepIfFormValid(step + 1)"
		>
			<!-- header title -->
			<div class="bg-green-500 px-6 py-4 text-white relative">
				<div class="flex justify-between items-baseline pr-4 mr-6">
					<h1 class="text-4xl font-bold">Bieten auf Auktionsangebot</h1>
				</div>

				<ui-button
					type="blank"
					class="absolute right-5 top-5"
					v-if="iframeModal"
					v-on:click="closeIframeModal()"
				>
					<ui-icon class="h-9 w-9 text-white" name="x" stroke-width="2" />
				</ui-button>
			</div>

			<div class="min-h-[30rem] flex flex-col">
				<ui-alert-errors
					v-if="otherErrorMessages.length > 0"
					:messages="otherErrorMessages"
					class="border-b border-red-300 rounded-none"
				/>

				<div class="overflow-y-auto">
					<bid-edit-step-1-auction
						v-if="step == 1"
						:form="form"
						:offer="offer"
						:bid="bid"
						:iframe-modal="iframeModal"
						:other-errors="otherErrors"
						:show-reference="false"
						:activeFutures="activeFutures"
						:bidValidityTime="bidValidityTime"
						v-on:tryGotoStepIfFormValid="tryGotoStepIfFormValid(step + 1)"
					/>
				</div>

				<div class="" v-if="step == 2">
					<div class="p-6">
						<my-lots-auction-offer-summary
							:offer="offer"
						></my-lots-auction-offer-summary>

						<div class="grid grid-cols-3 border-t border-gray-200 pt-2">
							<h4 class="text-gray-900 text-xl font-semibold hyphens">
								{{ __("Menge") }}
							</h4>
							<p class="text-gray-900 text-xl font-semibold col-span-2">
								<span v-html="offer.auction.qty_mt" /> t<span class="text-sm"
									>, ca.</span
								>
							</p>
						</div>

						<div
							class="grid grid-cols-3 border-t border-b border-gray-200 pt-2"
							v-if="form.price.type == 'FLAT'"
						>
							<h4 class="text-sm text-gray-900 text-xl font-semibold hyphens">
								{{ __("Ihr Preis") }}
							</h4>
							<p class="text-sm text-gray-900 text-xl font-semibold col-span-2">
								<span v-html="form.price.mt" />
								<span class="text-sm">&euro;/t</span>
							</p>
						</div>
						<div
							class="grid grid-cols-3 border-t border-b border-gray-200 pt-2"
							v-else-if="form.price.type == 'INDEXED'"
						>
							<h4 class="text-sm text-gray-900 text-xl font-semibold hyphens">
								{{ __("Premium based") }}
							</h4>
							<p class="text-sm text-gray-900 text-xl font-semibold col-span-2">
								{{ form.price.basis > 0 ? "+" : ""
								}}{{ $cropOptions.formatLocalizedNumber(form.price.basis) }}
								<span class="text-sm">&euro;/t</span>
								<span class="text-sm text-gray-900 font-normal">{{
									selectedFuture
								}}</span>
							</p>
						</div>

						<div class="grid grid-cols-3 border-t border-gray-200 pt-2">
							<h4 class="text-sm text-gray-900 hyphens">
								{{ __("Validity") }}
							</h4>
							<p class="text-sm col-span-2">
								{{ bidValidityDate }} bis {{ bidValidityTime }} (MEZ)
							</p>
						</div>

						<div class="sm:flex sm:items-start my-5">
							<!--div class="bg-red-500 rounded-lg text-white text-xxl mt-4 mx-2 p-2">
                                !
                            </div-->
							<ui-icon
								name="alert-triangle"
								class="h-14 w-14 mx-2 text-red-400"
								aria-hidden="true"
							/>
							<div class="font-medium bg-red-200 text-gray-900 py-2 px-1">
								{{
									__(
										"Wenn Sie für dieses Angebot Höchstbietender sind und mindestens den vom Verkäufer gewünschten Preis bieten, kommt am Ende der Auktion automatisch ein Kontrakt zustande."
									)
								}}
							</div>
						</div>

						<div class="font-medium text-green-500 my-5">
							{{
								__(
									"Bei Abschluss dieses Kontrakts wird Ihnen eine Kommission in Höhe von 0,25 € pro Tonne in Rechnung gestellt."
								)
							}}
						</div>
					</div>

					<div class="bg-gray-100 p-6 flex justify-between">
						<div>
							<ui-button type="secondary" v-on:click="step--" label="Back" />
						</div>
						<div>
							<ui-button
								type="primary"
								:disabled="submitButtonDisabled"
								v-on:click="submitForm()"
								label="Gebot abgeben"
							></ui-button>
						</div>
					</div>
				</div>
			</div>
		</form>
	</component>
</template>

<script>
import UiWizzard from "../components/Ui/Wizzard.vue";
let options = require("../cropOptions.js");
function padTo2Digits(num) {
	return num.toString().padStart(2, "0");
}

export default {
	mixins: [UiWizzard],
	props: {
		offer: {
			type: Object,
			required: true,
		},
		bid: {
			type: Object,
			required: true,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
		user: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		auction: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			form: Vue.observable(this.$inertia.form(this.bid)),
			step: 1,
			options: options,
		};
	},
	computed: {
		otherErrorMessages() {
			console.log(this.form);
			return Object.values(this.otherErrors || {});
		},
		selectedFuture() {
			console.log(this.activeFutures);
			return (this.activeFutures || []).filter(
				(f) => f.id == this.form.price.commodity_future_id
			)[0].name;
		},
		bidValidityDate() {
			var date = new Date(this.auction.bidding_ends_at);
			return (
				padTo2Digits(date.getDate()) +
				"." +
				padTo2Digits(date.getMonth() + 1) +
				"." +
				date.getFullYear()
			);
		},
		bidValidityTime() {
			var date = new Date(this.auction.bidding_ends_at);
			date.setMinutes(date.getMinutes() + 30); // valid until 30 minutes after bidding ends
			return (
				padTo2Digits(date.getHours()) + ":" + padTo2Digits(date.getMinutes())
			);
		},
	},
};
</script>
